var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',_vm._g({staticClass:"d-flex align-center justify-space-between area__card flashcard-item",attrs:{"height":"84"}},_vm.$listeners),[_c('div',{staticClass:"section__text--title area__name text-start"},[_vm._v(_vm._s(_vm.area.nombre))])])
}
var staticRenderFns = []

export { render, staticRenderFns }